// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"size-change"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.5 11V5.5H11M18.5 13V18.5H13M9 9L6.34315 6.34314M17.6569 17.6569L15 15M13.5 10.5L10.5 13.4978","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SizeChangeIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'size-change',
    ref,
    icon: element,
  },
));

SizeChangeIcon.displayName = 'SizeChangeIcon';

export default SizeChangeIcon;
